<section id="project1" class="projects" data-scroll-nav="0">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-7 col-md-7 col-sm-6"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div
							class="d-flex flex-column justify-content-center h-100 service-content"
						>
							<div>
								<h1 class="heading text-uppercase">miniaar</h1>
								<div class="points">
									<p>
										Miniaar offers bespoke attires, crafted with love and
										perfected with meticulous detail.
									</p>
									<p>
										<a
											class="text-decoration-underline"
											href="http://www.miniaar.com"
											target="_blank"
											>miniaar.com</a
										>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-5 col-md-5 col-sm-6">
						<div
							class="d-flex flex-column justify-content-center align-items-sm-end"
						>
							<div class="list-block">
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="1000"
									data-aos-delay="100"
								>
									<a href="{{ Url }}/project-details/miniaar#brandings"
										>Branding</a
									>
								</h3>
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="1500"
									data-aos-delay="150"
								>
									<a href="{{ Url }}/project-details/miniaar#animations"
										>Animations</a
									>
								</h3>
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="2000"
									data-aos-delay="200"
								>
									<a href="{{ Url }}/project-details/miniaar#ui-ux"
										>UI/UX Design</a
									>
								</h3>
								<h3
									class="mt-0 mb-2"
									data-aos="fade-up"
									data-aos-duration="2500"
									data-aos-delay="250"
								>
									<a href="{{ Url }}/project-details/miniaar#development"
										>Development</a
									>
								</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section data-scroll-nav="1" class="pb-0">
	<div class="container-fluid p-0">
		<div class="row">
			<div
				class="col-md-12 p-0"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<img
					src="{{ baseUrl }}/images/projects/miniaar/banner-image.jpg"
					alt="Branding agency in Dubai"
					width=""
					height=""
					loading="lazy"
				/>
			</div>
		</div>
	</div>
</section>
<section class="section bgColor about-project" data-scroll-nav="2">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="content">
					<p class="text-white">
						Miniaar, a platform synonymous with luxury fashion, sought to
						translate its opulence into a digital experience. Pixtar was
						entrusted with the task of not only capturing the essence of
						Miniaar's brand through design but also developing a sophisticated
						website with seamless functionality.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="bgColor branding" id="brandings" data-scroll-nav="3">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<h1 class="text-white heading">Branding</h1>
							<p class="text-white">
								Pixtar crafted a distinctive logo, premium quality visiting
								cards, invoice covers, and other corporate branding materials.
								The visual identity aimed to reflect Miniaar's commitment to
								celebrating and empowering women.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div
				class="col-md-12 p-0"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="imglist mb-3">
					<img
						src="{{ baseUrl }}/images/projects/miniaar/branding-image-01.jpg"
						alt="best web design company in dubai"
						width=""
						height=""
						loading="lazy"
					/>
				</div>
			</div>
			<div
				class="col-xxl-10 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row">
					<div
						class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto ps-md-0"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<img
							src="{{ baseUrl }}/images/projects/miniaar/branding-image-02.jpg"
							alt="web designing agency dubai"
							width=""
							height=""
							loading="lazy"
						/>
					</div>
					<div
						class="col-xl-6 col-lg-6 col-md-6 ps-md-0"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="list">
							<img
								src="{{
									baseUrl
								}}/images/projects/miniaar/branding-image-03.jpg"
								alt="Top branding agency in Dubai"
								width=""
								height=""
								loading="lazy"
							/>
							<img
								src="{{
									baseUrl
								}}/images/projects/miniaar/branding-image-04.jpg"
								alt="website development company dubai"
								width=""
								height=""
								loading="lazy"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="bgColor typography" data-scroll-nav="5">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="typography">
					<img
						src="{{ baseUrl }}/images/projects/miniaar/typography.jpg"
						alt="typography"
						width=""
						height=""
						loading="lazy"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					/>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="bgColor package" data-scroll-nav="6">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row mb-4">
					<div
						class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<h1 class="text-white heading mb-2">Package Design</h1>
							<p class="text-white">
								Branding is a strategic dance of logos, colors, and more,
								shaping a unique identity and perception in consumers' minds. It
								sets a brand apart, evoking emotions and building trust.
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<img
							src="{{
								baseUrl
							}}/images/projects/miniaar/package-design-image-01.jpg"
							alt="packaing2"
							width=""
							height=""
							loading="lazy"
							class="img1"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						/>
					</div>
					<div class="col-md-6">
						<img
							src="{{
								baseUrl
							}}/images/projects/miniaar/package-design-image-02.jpg"
							alt="box"
							width=""
							height=""
							loading="lazy"
							class="img2"
							data-aos="fade-up"
							data-aos-duration="2500"
							data-aos-delay="150"
						/>
					</div>
					<div class="col-md-6">
						<img
							src="{{
								baseUrl
							}}/images/projects/miniaar/package-design-image-03.jpg"
							alt="package-envelop"
							width=""
							height=""
							loading="lazy"
							data-aos="fade-up"
							data-aos-duration="3000"
							data-aos-delay="200"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="animation bgColor" id="animations" data-scroll-nav="7">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<div class="row mb-4">
					<div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10">
						<div class="content">
							<h1 class="heading text-white">Animations</h1>
							<p class="text-white">
								Branding is a strategic dance of logos, colors, and more,
								shaping a unique identity and perception in consumers' minds. It
								sets a brand apart, evoking emotions and building trust.
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div
						class="col-md-12"
						data-aos="fade-up"
						data-aos-duration="2500"
						data-aos-delay="100"
					>
						<!-- <img src="{{baseUrl}}/images/projects/dnour/animation.png" alt="Top branding agency in Dubai" width="" height=""> -->
						<video
							class="w-100 h-auto"
							id="myVideo"
							width="320"
							height="176"
							controls="controls"
							autoplay="true"
							muted="muted"
							loop="true"
							oncanplay="this.play()"
							onloadedmetadata="this.muted = true"
						>
							<source
								src="{{
									baseUrl
								}}/images/projects/miniaar/miniaar-brand-logo-animation.mp4"
								type="video/mp4"
							/>
							<!-- <source
								src="{{ baseUrl }}/images/projects/miniaar/group-583.jpg"
								type="video/ogg"
							/> -->
							Your browser does not support HTML5 video.
						</video>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="ui-ux pt-5" id="ui-ux" data-scroll-nav="8">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row mb-4">
					<div
						class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<h1 class="heading mb-2">UI/UX Design</h1>
							<p class="">
								Created an engaging and user-centric interface for the Miniaar
								website, ensuring a seamless and visually appealing user
								experience that resonated with the brand's ethos.
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div
						class="col-lg-9 mx-lg-auto"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<img
							class="w-100 h-auto desktopimg"
							id="myImage"
							width="320"
							height="176"
							src="{{ baseUrl }}/images/projects/miniaar/imacs.png"
							alt="Project Image"
						/>

						<!-- <img src="{{baseUrl}}/images/projects/dnour/dnour-desktop.png" alt="website developers in dubai" width="" height="" class="desktopimg"> -->

						<!-- <img src="{{baseUrl}}/images/projects/dnour/dnour-laptop.png" alt="web development company dubai" width="" height=""> -->
						<!-- <img
							class="w-100 h-auto desktopimg"
							id="myImage"
							width="320"
							height="176"
							src="{{ baseUrl }}/images/projects/miniaar/Group-583.png"
							alt="Project Image"
						/> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="development" id="development" data-scroll-nav="9">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="row mb-4">
					<div
						class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<div class="content">
							<h1 class="heading mb-2">Development</h1>
							<p class="">
								Pixtar leveraged its proprietary framework, P-Commerce, to
								develop Miniaar's website. The integration of Angular, Node.js,
								and MongoDB ensured a seamless and scalable platform. The
								development process prioritized functionality and user
								experience, offering a secure and efficient online space for
								luxury fashion enthusiasts.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="col-lg-12 p-0"
		data-aos="fade-up"
		data-aos-duration="2000"
		data-aos-delay="100"
	>
		<img
			src="{{ baseUrl }}/images/projects/miniaar/ima-01.png"
			alt="web development dubai"
			width=""
			height=""
		/>
		<!-- <video
			class="w-100 h-auto"
			id="myVideo2"
			width="320"
			height="176"
			autoplay="true"
			muted="muted"
			loop="true"
			oncanplay="this.play()"
			onloadedmetadata="this.muted = true"
		>
			<source
				src="{{ baseUrl }}/images/projects/miniaar/ima-01.png"
				type="video/mp4"
			/>
			<source
				src="{{ baseUrl }}/images/projects/miniaar/ima-01.ogg"
				type="video/ogg"
			/>
			Your browser does not support HTML5 video.
		</video> -->
		<div
			class="owlcarousel1"
			data-aos="fade-up"
			data-aos-duration="2000"
			data-aos-delay="100"
		>
			<owl-carousel-o [options]="desktopslider">
				<ng-container *ngFor="let slide of imageData">
					<ng-template
						class="slide"
						carouselSlide
						[id]="slide.id"
						*ngIf="slide.id <= 3"
					>
						<img
							[src]="slide.url"
							[alt]=""
							[title]=""
							width=""
							height=""
							loading="lazy"
						/>
					</ng-template>
				</ng-container>
			</owl-carousel-o>
		</div>
		<div
			class="owlcarousel2"
			data-aos="fade-up"
			data-aos-duration="2500"
			data-aos-delay="150"
		>
			<owl-carousel-o [options]="desktopslider1">
				<ng-container *ngFor="let slide of imageData">
					<ng-template
						class="slide"
						carouselSlide
						[id]="slide.id"
						*ngIf="slide.id >= 4 && slide.id <= 6"
					>
						<img
							[src]="slide.url"
							[alt]=""
							[title]=""
							width=""
							height=""
							loading="lazy"
						/>
					</ng-template>
				</ng-container>
			</owl-carousel-o>
		</div>
		<div class="owlcarousel3">
			<owl-carousel-o
				[options]="desktopslider2"
				data-aos="fade-up"
				data-aos-duration="3000"
				data-aos-delay="200"
			>
				<ng-container *ngFor="let slide of imageData">
					<ng-template
						class="slide"
						carouselSlide
						[id]="slide.id"
						*ngIf="slide.id >= 7 && slide.id <= 9"
					>
						<img
							[src]="slide.url"
							[alt]=""
							[title]=""
							width=""
							height=""
							loading="lazy"
						/>
					</ng-template>
				</ng-container>
			</owl-carousel-o>
		</div>
	</div>

	<div class="content container mt-5">
		<p class="text-justify">
			Pixtar's collaboration with Miniaar resulted in a digital platform that
			seamlessly blended luxury and technology. The case study highlights
			Pixtar's ability to create a harmonious synergy between design aesthetics,
			advanced web development, and security, delivering an unparalleled digital
			couture experience for Miniaar's audience.
		</p>
	</div>
</section>

<section
	class="next bg-black pb-0"
	data-aos="fade-up"
	data-aos-duration="2000"
	data-aos-delay="100"
>
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="next-block">
					<div class="in-line">
						<a
							href="{{ Url }}/project-details/detail-master"
							class="text-white font-bold border-radius-25"
						>
							<img
								src="{{
									baseUrl
								}}/images/projects/detail-master/detail-master-logo-min.jpg"
								alt="Best Web Designers in Dubai"
								width="280"
								height="280"
								loading="lazy"
							/>
							<h1 class="heading text-white">NEXT PROJECT</h1>
						</a>
						<!-- (click)="$event.preventDefault()  -->
					</div>
				</div>
			</div>
		</div>
		<div class="line"></div>
	</div>
</section>
